const jwt = require('jsonwebtoken');

module.exports = function setupJwt(appInstance, opts) {
    appInstance.jwt = {
        sign(payload, expiresIn = '1h') {
            return jwt.sign(payload, opts.jwtSecret, { expiresIn });
        },
        verify(token) {
            try {
                return jwt.verify(token, opts.jwtSecret);
            } catch {
                return null;
            }
        },
        middleware(req, res, next) {
            const authHeader = req.headers.authorization;
            let token = null;
            if (authHeader && authHeader.startsWith('Bearer ')) {
                token = authHeader.split(' ')[1];
            } else if (req.cookies && req.cookies.token) {
                token = decodeURIComponent(req.cookies.token);
            }
            if (!token) {
                if (res.json) {
                    return res.json({ error: 'Unauthorized: No token provided' }, 401);
                }
                res.writeHead(401, { 'Content-Type': 'application/json' });
                return res.end(JSON.stringify({ error: 'Unauthorized: No token provided' }));
            }
            try {
                const decoded = jwt.verify(token, opts.jwtSecret);
                req.user = decoded;
                next();
            } catch {
                if (res.json) {
                    return res.json({ error: 'Unauthorized: Invalid token' }, 401);
                }
                res.writeHead(401, { 'Content-Type': 'application/json' });
                return res.end(JSON.stringify({ error: 'Unauthorized: Invalid token' }));
            }
        }
    };
};
